// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CreateSocialItemModal-cls1__f36d00e7b0b637d50e37{/*!*/}.CreateSocialItemModal-cls2__cf997144bcc7c52b8c54{flex:1 1;padding-bottom:24px;padding-bottom:var(--spacing-sm-24, 24px);overflow:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CreateSocialItemModal-cls1__f36d00e7b0b637d50e37",
	"cls2": "CreateSocialItemModal-cls2__cf997144bcc7c52b8c54 CreateSocialItemModal-cls1__f36d00e7b0b637d50e37"
};
export default ___CSS_LOADER_EXPORT___;
